import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import resources from 'src/locales/resources';

function language_reset(){
  // 言語が設定されていない時に呼び出す用
  // 言語を設定し、設定した言語を返します
  localStorage.setItem('lng', 'en')
  return 'en'
}

i18n.use(initReactI18next).init({
  resources,
  fallbackLng: localStorage.getItem('lng') || language_reset(),
  debug: true,
 
  interpolation: {
    escapeValue: false
  }

});
 
export default i18n;


// WEBPACK FOOTER //
// ./src/i18n.js